import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {TempBasicComponent} from './layout/temp-basic/temp-basic.component';
import {AppComponent} from './app.component';
import {BnNgIdleService} from 'bn-ng-idle';
import {AdminComponent} from './layout/admin/admin.component';
import {AuthComponent} from './layout/auth/auth.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from './shared/shared.module';
import {MenuItems} from './shared/menu-items/menu-items';
import {BreadcrumbsComponent} from './layout/admin/breadcrumbs/breadcrumbs.component';
import {AngularWebStorageModule, LocalStorageService} from 'angular-web-storage';
import {AuthConfig, AuthHttp, JwtHelper} from 'angular2-jwt';
import {ToastyModule} from 'ng2-toasty';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {Http, HttpModule, RequestOptions} from '@angular/http';
import 'rxjs/add/observable/defer';
import {AsyncPipe} from '@angular/common';
import {NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule} from 'ngx-ui-loader';
import {AngularResizedEventModule} from 'angular-resize-event';
import {AuthInterceptor} from './services/interceptors/auth.interceptor';
import {JwtModule} from '@auth0/angular-jwt';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {DxTreeViewModule} from 'devextreme-angular';
import {
   DEFAULT_TIMEOUT,
   defaultTimeout,
   TimeOutInterceptorService
} from './appbago/ficha-kam/servicios/interceptors/time-out-interceptor.service';
import {MenuLateralModule} from './layout/admin/menu-lateral/menu-lateral.module';

export function authHttpServiceFactory(http: Http, options: RequestOptions, storage: LocalStorageService) {
   const authConfig = new AuthConfig({
      headerPrefix: 'JWT',
      tokenGetter: (() => storage.get('jwt')),
   });
   
   return new AuthHttp(authConfig, http, options);
}

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
   // bgsColor: '#OOACC1',
   // bgsOpacity: 0.5,
   // bgsPosition: POSITION.bottomCenter,
   // bgsSize: 60,
   // bgsType: SPINNER.rectangleBounce,
   // fgsColor: '#00ACC1',
   // fgsPosition: POSITION.centerCenter,
   // fgsSize: 60,
   // fgsType: SPINNER.chasingDots,
   // logoUrl: 'assets/angular.png',
   // pbColor: '#FF0000',
   // pbDirection: PB_DIRECTION.leftToRight,
   // pbThickness: 5,
   // text: 'Welcome to ngx-ui-loader',
   // textColor: '#FFFFFF',
   // textPosition: POSITION.centerCenter
};

@NgModule({
   declarations: [
      AppComponent,
      AdminComponent,
      AuthComponent,
      BreadcrumbsComponent,
      TempBasicComponent,
   ],
   imports: [
      BrowserModule,
      BrowserAnimationsModule,
      HttpModule,
      AppRoutingModule,
      SharedModule,
      AngularWebStorageModule,
      NgxDatatableModule,
      ToastyModule,
      NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
      NgxUiLoaderRouterModule,
      NgxUiLoaderHttpModule,
      AngularResizedEventModule,
      JwtModule.forRoot({
         config: {
            throwNoTokenError: false,
         }
      }),
      DxTreeViewModule,
      MenuLateralModule,
   ],
   schemas: [],
   providers: [
      MenuItems,
      BnNgIdleService,
      LocalStorageService,
      AsyncPipe,
      JwtHelper, {
         provide: AuthHttp,
         useFactory: authHttpServiceFactory,
         deps: [Http, RequestOptions]
      },
      {
         provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
      },
      [
         {
            provide: HTTP_INTERCEPTORS,
            useClass: TimeOutInterceptorService,
            multi: true,
         }
      ],
      [
         {
            provide: DEFAULT_TIMEOUT,
            useValue: defaultTimeout
         }
      ]
   ],
   bootstrap: [AppComponent]
})
export class AppModule {
}
